import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles';
import CtaButton from '../components/CtaButton';
import ServiceCard from '../components/ServiceCard';
import BlogCard from '../components/BlogCard';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Hero */}
      <header style={styles.hero}>
        <div style={styles.container}>
          <h1
            style={{
              ...styles.heroTitle,
              animation: 'fadeIn 1s cubic-bezier(0.2, 0.8, 0.2, 1) forwards',
            }}
          >
            Financial<br />
            Clarity.<br />
            Restored.
          </h1>
          <p
            style={{
              ...styles.heroSub,
              maxWidth: '480px',
              marginBottom: '64px',
              animation: 'fadeIn 1s cubic-bezier(0.2, 0.8, 0.2, 1) 0.1s forwards',
              opacity: 0,
            }}
          >
            Professional credit repair strategies for individuals seeking a clean slate.
            We remove the errors that hold you back.
          </p>
          <CtaButton text="Start your analysis" onClick={() => navigate('/contact')} />
        </div>
      </header>

      {/* Services */}
      <section style={styles.container}>
        <h2 style={styles.sectionHeader}>The Correction Method.</h2>
        <div style={styles.servicesGrid}>
          <ServiceCard
            title="Audit"
            description="We identify inaccurate, unverifiable, and obsolete items on your credit reports."
          />
          <ServiceCard
            title="Dispute"
            description="Our team initiates direct challenges with the three major credit bureaus."
          />
          <ServiceCard
            title="Monitor"
            description="Real-time tracking of score changes and deletions as they happen."
          />
        </div>
      </section>

      {/* Stats */}
      <section style={styles.statsSection}>
        <div style={styles.container}>
          <div style={styles.statsGrid}>
            <div style={{ textAlign: 'left' }}>
              <span style={styles.statNumber}>45d</span>
              <span style={styles.statLabel}>Avg. Turnaround</span>
            </div>
            <div style={{ textAlign: 'left' }}>
              <span style={styles.statNumber}>12k+</span>
              <span style={styles.statLabel}>Items Removed</span>
            </div>
            <div style={{ textAlign: 'left' }}>
              <span style={styles.statNumber}>98%</span>
              <span style={styles.statLabel}>Client Satisfaction</span>
            </div>
          </div>
        </div>
      </section>

      {/* Blog */}
      <section style={{ ...styles.container, ...styles.blogSection }}>
        <h2 style={styles.sectionHeader}>From The Blog.</h2>
        <div className="blog-grid" style={styles.blogGrid}>
          <BlogCard
            imgSrc="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&q=80"
            imgAlt="Credit Score Tips"
            tag="Credit Education"
            title="5 Factors That Impact Your Credit Score the Most"
            excerpt="Understanding what drives your score is the first step toward improving it."
          />
          <BlogCard
            imgSrc="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=80"
            imgAlt="Dispute Process"
            tag="Dispute Process"
            title="How to Successfully Dispute an Error on Your Credit Report"
            excerpt="A step-by-step breakdown of the dispute process and what to expect from bureaus."
          />
          <BlogCard
            imgSrc="https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=600&q=80"
            imgAlt="Financial Planning"
            tag="Financial Health"
            title="Rebuilding Credit After a Major Financial Setback"
            excerpt="Recovery is possible. Here's how our clients rebuild strong financial foundations."
          />
        </div>
      </section>

      {/* Contact CTA */}
      <section
        style={{
          backgroundColor: '#1B2B3E',
          color: '#F3F4F6',
          padding: '120px 0',
        }}
      >
        <div style={styles.container}>
          <h2 style={styles.expectionsTitle}>Free Consultation.</h2>
          <p
            style={{
              fontSize: '20px',
              color: 'rgba(243,244,246,0.7)',
              maxWidth: '500px',
              lineHeight: '1.6',
              marginBottom: '48px',
            }}
          >
            Speak with a specialist today to understand your removal options. It's free and takes less than 15 minutes.
          </p>
          <CtaButton text="Get started today" light onClick={() => navigate('/contact')} />
        </div>
      </section>
    </div>
  );
};

export default HomePage;
